export const routes = {
  login: '/sign-in',
  twoFactorAuthentication: '/two-factor-authentication',
  resetPassword: '/reset-password',
  signUp: '/sign-up',
};
